import { render, staticRenderFns } from "./BCXFormFieldError.vue?vue&type=template&id=cab6524c&scoped=true"
import script from "./BCXFormFieldError.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXFormFieldError.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXFormFieldError.vue?vue&type=style&index=0&id=cab6524c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab6524c",
  null
  
)

export default component.exports